import styled from "styled-components";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";

export const CardContainerWrapper = styled(CardContainer)<{ isUnlocked: boolean }>(({ theme, isUnlocked }) => {
    return {
        margin: `0 ${theme.spacing.medium} ${theme.spacing.medium}`,
        padding: `${theme.spacing.medium} 0`,
        border: `1.4px solid ${theme.colors[theme.colorMode].background_Primary}`,
        background: isUnlocked
            ? "radial-gradient(106.43% 103% at 4.88% 7.44%, rgba(27, 166, 114, 0.09) 0%, rgba(27, 166, 114, 0.00) 100%), #FFF;"
            : "radial-gradient(106.43% 103% at 4.88% 7.44%, rgba(60, 18, 178, 0.09) 0%, rgba(60, 18, 178, 0.00) 100%), #FFF;",
        position: "relative",
        overflow: "hidden",
    };
});

export const HeaderContainer = styled.div(({ theme }) => {
    return {
        display: "block",
        alignItems: "center",
        paddingLeft: theme.spacing.medium,
        marginBottom: theme.spacing.xSmall,
    };
});
